import * as React from "react";
import auth from "../../Auth";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import ColumnMenu from "../../Shared/GridComponents/ColumnMenu";
import { CellRender, GridNoRecord, StatusCell } from "../../Shared/GridComponents/CommonComponents";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { process, State } from "@progress/kendo-data-query";
import { DetailColumnCell, ViewMoreComponent, ReqNumberCell } from "./GlobalActions";
import { convertShiftDateTimeWithSeconds, updatedCreateQueryString } from "../../ReusableComponents";
import "../../../assets/css/App.css";
import "../../../assets/css/KendoCustom.css";
import CompleteSearch from "../../Shared/Search/CompleteSearch";
import { applySettingFilters, currencyFormatter, dateFormatter, downloadExcel, getClientSettingsData, successToastr } from "../../../HelperMethods";
import reportServices from "../../Shared/Services/ReportServices";
import { EXCEL_DOWNLOAD_INPROGRESS } from "../../Shared/AppMessages";
import BreadCrumbs from "../../Shared/BreadCrumbs/BreadCrumbs";
import { GridDataState, LocalizationResource, SETTINGS, SettingCategory } from "../../Shared/AppConstants";
import { storeFilters } from "../../Shared/PersistFilteredData";
import { LocalizationHelper } from "../../../Localization/helpers/LocalizationHelper";

export interface CandidateSubmissionAttemptsReportProps { }

export interface CandidateSubmissionAttemptsReportState {
    searchString: string;
    data: any;
    allData?: any;
    clientId?: string;
    vendorId?: string;
    dataState: any;
    showRemoveModal?: boolean;
    showCopyModal?: boolean;
    showLoader?: boolean;
    totalCount?: number;
    showHoldPositionModal?: any;
    showReqHistoryModal?: any;
    onFirstLoad: boolean;
    result?: any;
    dataCopy?: any;
    displayEntityNumber?: boolean;

}

class CandidateSubmissionAttemptsReport extends React.Component<CandidateSubmissionAttemptsReportProps, CandidateSubmissionAttemptsReportState> {
    public reqId: string;
    public dataItem: any;
    public openModal: any;
    public expandDataState: any;
    dataState;
    data = [];
    // aggregates = [
    //     { field: "billRateAccepted", aggregate: "count" },
    //   ];
    constructor(props: CandidateSubmissionAttemptsReportProps) {
        super(props);
        this.dataState = {
            skip: 0,
            take: 10,
            group: [{ field: "reqNumber", dir: "desc"}],
        };
        this.state = {
            searchString: "",
            data: [],
            result:
                { data: [] },
            dataState: this.dataState,
            clientId: auth.getClient(),
            vendorId: auth.getVendor(),
            onFirstLoad: true,
            showLoader: true,
            displayEntityNumber: false
        };

    }
    componentDidMount() {
        this.getClientSetting(this.state.clientId);
    }
    getClientSetting = (id) => {
        getClientSettingsData(id).then((res) => {
            applySettingFilters(res, SettingCategory.REQUISITION, SETTINGS.DISPLAY_ENTITY_NUMBER, (response) => {
                this.setState({ displayEntityNumber: response });
            });
        });
    };

    getCandidateSubmissionAttemptsReport = (dataQuery?, dataState?, isAdvanceSearch?) => {

        dataQuery = { sort: [{ field: "timeOfSubmission", dir: "desc" }], ...dataQuery };

        var dataCopy: State = {
            take: dataQuery.take,
            skip: dataQuery.skip,
            sort: dataQuery.sort,
        };
        if (!isAdvanceSearch) {
            this.state.dataState.skip = 0;
        }
        this.state.dataState.filter = dataQuery.filter;
        this.setState({ showLoader: true, onFirstLoad: false, dataState: this.state.dataState });
        let finalQueryString = updatedCreateQueryString(dataQuery, this.state.clientId, this.state.vendorId);

        axios.get(`api/report/candsubmissionattempts?${`$count=true&`}${finalQueryString}`).then((res) => {
            this.data = res.data.items;
            let dataStateCopy = {
                skip: 0,
                take: this.state.dataState.take,
                group: this.state.dataState.group
            };
            this.expandDataState = dataStateCopy;
            this.setState(
                {
                    data: res.data.items,
                    result: process(res.data.items, dataStateCopy),
                    showLoader: false,
                    onFirstLoad: false,
                    dataCopy: dataCopy,
                    totalCount: res.data.count
                }
            );
        });
    };

    expandChange = (dataItem) => {
        const { data } = this.state;
        const reportData = data.map((item) => {
            if (item === dataItem) {
                item.expanded = !item.expanded;
            }
            return item;
        });
        this.setState({
            data: reportData,
            result: process(reportData, this.expandDataState)
        });
    };

    onDataStateChange = (changeEvent) => {
        storeFilters(GridDataState.REPORTCANDIDATESUBMISSIONATTEMPTS,changeEvent.dataState)
        let dataState2;
        if (changeEvent.dataState.filter) {
          dataState2 = {
            filter: changeEvent.dataState.filter,
            skip: changeEvent.dataState.skip,
            take: changeEvent.dataState.take,
            group: changeEvent.dataState.group,
          };
        }
        if (changeEvent.dataState.sort) {
          dataState2 = {
            sort: changeEvent.dataState.sort,
            skip: changeEvent.dataState.skip,
            take: changeEvent.dataState.take,
            group: changeEvent.dataState.group,
            filter: changeEvent.dataState.filter ? changeEvent.dataState.filter : null,
          };
        }
        if (changeEvent.dataState.sort == undefined && changeEvent.dataState.filter == undefined) {
          dataState2 = {
            skip: changeEvent.dataState.skip,
            take: changeEvent.dataState.take,
            group: changeEvent.dataState.group,
          };
        }
        if (this.state.dataState.group.length == changeEvent.dataState.group.length) {
          return this.setState(
            {
              dataState: dataState2,
            },
            () => this.getCandidateSubmissionAttemptsReport(this.state.dataState, dataState2, true)
          );
        } else {
              this.setState(this.createAppState(changeEvent.dataState))
          }
    };
    createAppState(dataState) {
        // const groups = dataState.group;
        // if (groups) {
        //     groups.map((group) => (group.aggregates = this.aggregates));
        // }
        let dataState2 = {
            skip: dataState.skip,
            take: dataState.take,
            group: dataState.group,
        };
        return {
            result: process(this.data, dataState2),
            dataState: dataState2,
        };
    }
    ExpandCell = (props) => <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />;

    cellRender = (td, props) => {
        if(td && td.props.children && props.rowType === "groupHeader" && props.dataItem.field == "billRateAccepted"){
          let children = <span style={{color:'black'}}>Bill Rate Accepted: {td.props.children.props.children[1]}</span>
          return React.cloneElement(td, td.props, children);
        }
        if(td && td.props.children && props.rowType === "groupHeader" && props.dataItem.field == "timeOfSubmission"){
            
            let children = <span style={{color:'black'}}>{dateFormatter(new Date(td.props.children.props.children[1]))} {convertShiftDateTimeWithSeconds(td.props.children.props.children[1])}</span>
            return React.cloneElement(td, td.props, children);
          }
        return td
      } 

      cellRender2(cellProps) {
        if (cellProps.rowType === "groupHeader") {

            let billRateAcceptedCount = cellProps.dataItem.items.length;

            return (
                <div className="time-and-expense">
                    {cellProps.dataItem.field == "billRateAccepted" ?
                        <><span > Count: {billRateAcceptedCount}</span>
                        </> : ""}
                </div>
            );
        }
        return <td></td>;
    } 

    render() {
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="container-fluid mt-3 mb-3 d-md-block d-block">
                    <div className="row pt-1 pb-1 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-12 fonFifteen paddingLeftandRight d-flex justify-content-between align-items-center">
                            <BreadCrumbs></BreadCrumbs>
                            <span title="Export to Excel" onClick={() => this.downloadCandidateSubmissionAttemptsReportExcel(this.state.data)} className="mr-2 float-right text-dark shadow invoice cursor-pointer">
                                <FontAwesomeIcon icon={faFileExcel} style={{ color: "white" }} className={"faclock_size d-block"}></FontAwesomeIcon>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <CompleteSearch
                        placeholder="Search text here!"
                        handleSearch={this.getCandidateSubmissionAttemptsReport}
                        entityType={"CandidateSubmissionAttemptsReport"}
                        onFirstLoad={this.state.onFirstLoad}
                        page="CandidateSubmissionAttemptsReport"
                        persistSearchData={true}
                    />
                    <div className="myOrderContainer global-action-grid table_responsive-TABcandidates frozen-column" id="grouping-performance-grid">
                        <Grid
                            resizable={false}
                            reorderable={false}
                            sortable={true}
                            pageable={{ pageSizes: true }}
                            groupable={{ footer: "none" }}
                            cellRender={this.cellRender}
                            data={this.state.result.data}
                            total={this.state.totalCount}
                            onDataStateChange={this.onDataStateChange}
                            {...this.state.dataState}
                            {...this.state.dataCopy}
                            className="kendo-grid-custom k-widget lastchild"
                            onExpandChange={this.expandChange}
                            expandField="expanded"
                            detail={ViewMoreComponent}
                        >
                            <GridNoRecords>
                                {GridNoRecord(this.state.showLoader)}
                            </GridNoRecords>

                            <GridColumn
                                field="timeOfSubmission"
                                width={170}
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                title="Submission Date/Time"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Submission Date/Time", null, true)}
                            />
                            <GridColumn field="reqNumber" width={130} title="Req#" cell={ReqNumberCell} columnMenu={ColumnMenu} />
                            <GridColumn
                                field="region"
                                width={140}
                                title="Region"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Region")}
                                filter="text"
                            />
                            <GridColumn
                                field="division"
                                width={140}
                                title="Division"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Division")}
                                filter="text"
                            />
                            <GridColumn
                                field="location"
                                width={140}
                                title={LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")}
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Location")}
                            />
                            <GridColumn
                                field="position"
                                width={140}
                                title="Position"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Position")}
                            />
                            <GridColumn
                                field="vendor"
                                width={140}
                                title="Vendor"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Vendor")}
                            />
                            <GridColumn
                                field="candidateName"
                                width={140}
                                title="Candidate Name"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Candidate Name")}
                            />
                            <GridColumn
                                field="serviceCategory"
                                width={140}
                                title="Service Category"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Service Category")}
                            />
                            <GridColumn
                                field="serviceType"
                                width={140}
                                title="Service Type"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Service Type")}
                            />
                            <GridColumn
                                field="billTypeInputted"
                                width={140}
                                title="Bill Type"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Bill Type")}
                            />
                            <GridColumn
                                field="billRateInputted"
                                width={140}
                                title="Bill Rate"
                                headerClassName="text-right pr-4"
                                filter="numeric"
                                columnMenu={ColumnMenu}
                                cell={(props) => {
                                    if (props.rowType == "groupHeader") {
                                        return <td colSpan={0} className="d-none"></td>;
                                      }
                                    return (
                                        <td
                                            contextMenu={"Bill Rate"}
                                            style={{ textAlign: "right"}}
                                            className="pr-4"
                                        >
                                            {currencyFormatter(props.dataItem.billRateInputted)}
                                        </td>
                                    );
                                }}
                            />
                            <GridColumn
                                field="billRateAccepted"
                                width={140}
                                title="Bill Rate Accepted"
                                columnMenu={ColumnMenu}
                                cell={(props) => {
                                    if (props.rowType == "groupHeader") {
                                        return <td colSpan={0} className="vendor-details-with-zero">{this.cellRender2(props)}</td>;
                                    }
                                    return (
                                      <td contextMenu={"Bill Rate Accepted"} title={props.dataItem.billRateAccepted != null ? props.dataItem.billRateAccepted : "-"}>
                                        {props.dataItem.billRateAccepted != null ? props.dataItem.billRateAccepted : "-"}
                                      </td>
                                    );
                                  }}
                            />
                            <GridColumn
                                field="holidayBillRateInputted"
                                width={140}
                                title="Holiday Bill Rate"
                                headerClassName="text-right pr-4"
                                filter="numeric"
                                columnMenu={ColumnMenu}
                                cell={(props) => {
                                    if (props.rowType == "groupHeader") {
                                        return <td colSpan={0} className="d-none"></td>;
                                    }
                                    return (
                                        <td
                                            contextMenu={"Holiday Bill Rate"}
                                            style={{ textAlign: "right" }}
                                            className="pr-4"
                                        >
                                            {currencyFormatter(props.dataItem.holidayBillRateInputted)}
                                        </td>
                                    );
                                }}
                            />
                            <GridColumn
                                field="holidayBillRateAccepted"
                                width={190}
                                title="Holiday Bill Rate Accepted"
                                columnMenu={ColumnMenu}
                                cell={(props) => {
                                    if (props.rowType == "groupHeader") {
                                        return <td colSpan={0} className="vendor-details-with-zero">{this.cellRender2(props)}</td>;
                                    }
                                    return (
                                        <td contextMenu={"Holiday Bill Rate Accepted"} title={props.dataItem.holidayBillRateAccepted != null ? props.dataItem.holidayBillRateAccepted : "-"}>
                                            {props.dataItem.holidayBillRateAccepted != null ? props.dataItem.holidayBillRateAccepted : "-"}
                                        </td>
                                    );
                                }}
                            />
                            <GridColumn
                                field="vendorContact"
                                width={140}
                                title="Vendor Contact"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Vendor Contact")}
                            />
                           
                            <GridColumn
                                width={90}
                                field="nsCostCenter"
                                title={LocalizationHelper.getLocalizedTitle(LocalizationResource.PO_Label, "PO")}
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Ns Cost Center")}

                            />
                            {this.state.displayEntityNumber && (
                                <GridColumn
                                    width={90}
                                    field="entityNumber"
                                    title="Entity #"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Entity #")}
                                />
                            )}
                            <GridColumn
                                locked
                                field="status"
                                width="220px"
                                title="Requisition Status" columnMenu={ColumnMenu} cell={StatusCell} />
                            <GridColumn
                                locked
                                sortable={false}
                                field="expanded"
                                width="80px"
                                title="View More"
                                cell={this.ExpandCell} />
                        </Grid>
                    </div>
                </div>
            </div>
        );
    }

    downloadCandidateSubmissionAttemptsReportExcel = (data) => {
        if (data.length === 0) {
            return;
        }
        var finalState: State = {
            ...this.state.dataState,
            take: null,
            skip: 0,
        };
        successToastr(EXCEL_DOWNLOAD_INPROGRESS);
        reportServices.getCandidateSubmissionAttemptsReportForExcel(this.state.clientId, this.state.vendorId, finalState, this.state.displayEntityNumber).then((res: any) => {
            if (res) {
                downloadExcel("Candidate Presentation Attempts Report.xlsx", res.data);
            }
        });
    }
}
export default CandidateSubmissionAttemptsReport;
